"use client";

import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserSessionPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: 'AIzaSyAMYc2xNS4gejPHrXMiC4hGqt8QycEaVtQ',
  authDomain: 'proxi-db957.firebaseapp.com',
  projectId: 'proxi-db957',
  storageBucket: 'proxi-db957.appspot.com',
  messagingSenderId: '886078234203',
  appId: '1:886078234203:web:1ceae1d24e1e894e9c297e',
  measurementId: 'G-G3EQ6WCKEK',
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Auth persistence is split by account type instead of set globally:
//
//  - Guest users (anonymous and per-invitation custom-token sign-ins) are
//    scoped to the tab via scopeAuthToTab() at each guest sign-in site, so a
//    contributor holding several invitation links can open them in separate
//    tabs — or over time — without one invitation's session hijacking
//    another's interview.
//  - Real accounts (Google / LinkedIn / email / phone) are migrated to
//    browserLocalPersistence centrally in auth-provider's onIdTokenChanged,
//    so returning visitors stay signed in across browser restarts.
//
// Deliberately no global setPersistence call here: at startup Firebase
// restores each user from whichever storage layer it was saved under, and a
// global call would migrate a restored user out of its intended layer (e.g.
// pull a tab-scoped guest into browser-wide storage on reload).

/**
 * Scope the NEXT sign-in to this browser tab (sessionStorage). Must be
 * awaited before every anonymous / custom-token guest sign-in — persistence
 * is sticky on the auth instance, so skipping it would let a guest session
 * land in browser-wide storage and leak across tabs and restarts.
 */
export const scopeAuthToTab = () =>
  setPersistence(auth, browserSessionPersistence).catch(() => {
    // Storage unavailable (e.g. blocked in an embedded/private context) —
    // Firebase falls back to in-memory persistence for this page load.
  });

export { app, auth };

export default app;
